var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414L13.414 12l3.293 3.293a1 1 0 1 1-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L10.586 12 7.293 8.707a1 1 0 1 1 1.414-1.414L12 10.586z"}));
}

CloseIcon.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
